import { Domain } from '@enums/Domain'

const displayDesktop = { lg: 'block', md: 'block', sm: 'none' } as const
const displayMobile = { lg: 'none', md: 'none', sm: 'block' } as const

export const cardContentTextConfig = {
  [Domain.ACKO]: {
    specificGap: 'spacing-6',
    alignItems: 'flex-start',
    textAlign: 'left',
    titleFontStyle: { lg: 'um_text-2xl/bold', md: 'um_text-xl/bold', sm: 'um_text-base/bold' },
    subtitleFontStyle: { lg: 'um_text-sm/normal', md: 'um_text-sm/normal', sm: 'um_text-xs/normal' },
    displayDesktop,
    displayMobile,
  },
  [Domain.ACKODRIVE]: {
    specificGap: { lg: 'spacing-16', md: 'spacing-8', sm: 'spacing-6' },
    alignItems: { lg: 'center', md: 'center', sm: 'flex-start' },
    textAlign: { lg: 'center', md: 'center', sm: 'left' },
    titleFontStyle: { lg: 'um_text-2xl/bold', md: 'um_text-lg/bold', sm: 'um_text-base/bold' },
    subtitleFontStyle: { lg: 'um_text-lg/normal', md: 'um_text-xs/normal', sm: 'um_text-xs/normal' },
    displayDesktop,
    displayMobile,
  },
}
